import { CustomerContact } from 'CustomerContacts/types'
import { ContactBody } from 'CustomerContacts/view/forms/ContactModalForm/useContactModalForm'
import { emailToName } from 'CustomerContacts/utils/emailToName'

export function toContactBody({
  name,
  email,
  purposes,
  notificationSubscriptions
}: CustomerContact): ContactBody {
  return {
    name: name ?? emailToName(email),
    email,
    purposes,
    notificationSubscriptions
  }
}
